import PropTypes from 'prop-types';
import {useCallback} from 'react';
import {useDropzone} from 'react-dropzone';
import {renderUpload, shouldRenderUploadProgress} from './commons/UploadRenderUtil';

export const BasicFileUpload = (
  {
    accept,
    basicView,
    className,
    onUpload,
    uploadProgress,
    uploadingView,
  }
) => {
  const onDropAccepted = useCallback((files, event) => {
    onUpload && onUpload(files, event);
  }, [onUpload]);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    accept: accept,
    multiple: false,
    onDropAccepted,
  });

  const renderUploadView = () => {
    if (uploadingView) {
      return uploadingView;
    }

    return renderUpload({className, isDragActive, uploadProgress});
  };

  return uploadingView && shouldRenderUploadProgress(uploadProgress) ? (
    renderUploadView()
  ) : (
    <div className={`BasicFileUpload ${className} ${isDragActive ? 'active' : 'inactive'}`}
         data-testid="BasicFileUpload" {...getRootProps()}>
      {basicView}
      <input {...getInputProps()}/>
    </div>
  );
};

BasicFileUpload.propTypes = {
  accept: PropTypes.string.isRequired,
  basicView: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
  uploadProgress: PropTypes.number,
  uploadingView: PropTypes.node,
};

BasicFileUpload.defaultProps = {
};

export default BasicFileUpload;